import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { LOGIN } from './constants';
import { authSelectors } from '../views/containers/Login/state';

class PrivateRoute extends Component {
    render() {
        return authSelectors.isAuthenticated() ?
            <Route path={this.props.path} component={this.props.component} /> :
            <Redirect to={{
                pathname: LOGIN,
                state: {
                    from: this.props.location
                }
            }} />
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        state: state
    }
};

export default connect(mapStateToProps)(PrivateRoute);